module.exports = __webpack_public_path__ + "static/media/falcon-torch-carrying-case-4.5f9692ea.jpg";